import * as t from './actionTypes';
import { FetchDeletionPoliciesResponseAction, Action, CustomEventsResponseAction } from './types';

const initialState = {
  customEvents: [],
  isLoading: false,
  isError: false,
  retentionPeriodsByEventName: {},
  isLoadingDeletionPolicies: false,
  isErrorDeletionPolicies: false,
};

const customEventsReducer = (state = initialState, action: Action) => {
  switch (action.type) {
    case t.FETCH_CUSTOM_EVENTS_RESPONSE:
      return {
        ...state,
        customEvents: (action as CustomEventsResponseAction).customEvents,
        isLoading: false,
        isError: false,
      };
    case t.FETCH_CUSTOM_EVENTS_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case t.FETCH_CUSTOM_EVENTS_ERROR:
      return {
        ...state,
        isLoading: false,
        isError: true,
      };
    case t.FETCH_DELETION_POLICIES_BY_PROJECT_RESPONSE: {
      return {
        ...state,
        retentionPeriodsByEventName: (action as FetchDeletionPoliciesResponseAction)
          .retentionPeriodsByEventName,
        isErrorDeletionPolicies: false,
        isLoadingDeletionPolicies: false,
      };
    }
    case t.FETCH_DELETION_POLICIES_BY_PROJECT_REQUEST: {
      return {
        ...state,
        isLoadingDeletionPolicies: true,
      };
    }
    case t.FETCH_DELETION_POLICIES_BY_PROJECT_ERROR: {
      return {
        ...state,
        isLoadingDeletionPolicies: false,
        isErrorDeletionPolicies: true,
      };
    }
    case t.UPDATE_DELETION_POLICIES_RESPONSE: {
      return {
        ...state,
        isLoadingDeletionPolicies: false,
      };
    }
    case t.UPDATE_DELETION_POLICIES_REQUEST: {
      return {
        ...state,
        isLoadingDeletionPolicies: true,
      };
    }
    case t.UPDATE_DELETION_POLICIES_ERROR: {
      return {
        ...state,
        isLoadingDeletionPolicies: false,
      };
    }
    default: {
      return state;
    }
  }
};

export default customEventsReducer;
